<template>
  <div id="serp__filter--clear-button-container" class="serp__filter--clear-button-container q-col-12 q-pb-1 q-text-center " v-if="hasSelectedFilters">
    <ClearFiltersButton/>
  </div>
</template>
<script setup lang="ts">
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {toRefs} from "vue";
import ClearFiltersButton from "@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButton.vue";


const filtersStore = useFiltersStore()
const {hasSelectedFilters} = toRefs(filtersStore)

</script>

<style>
#smartsearch-serp__results .serp__filter--clear-button {
  /*width: 100%;*/
}

@media (min-width: 768px) {
  #smartsearch-serp__results .serp__filter--clear-button-container {
    display: none;
  }
}

</style>
